import React, { useContext } from "react";
import {LanguageContext} from "../ApplicationFrame/Translation";

export default () => useContext(LanguageContext);